import { StatsInfo } from "../GameStats/stat-info-type";
import Styles from "./StatsLegend.module.scss";

type StatsLegendProps = {
  // The currently displayed columns; their `name`/`def` drive the key. Columns without a `def`
  // (e.g. the pinned Player / Date / Opponent columns) are skipped.
  columns: StatsInfo[];
  // When true (the Fielding → Innings Played view) the primary/secondary position color key is
  // prepended, explaining the highlighted cells in that table.
  showPositionKey?: boolean;
};

/**
 * Renders the abbreviation key for whatever stats view is showing (Batting/Pitching/Fielding ×
 * Standard/Advanced/Breakdown/...). Because it reads each column's own `def`, the legend always
 * matches the table above it and needs no per-tab maintenance.
 */
export default function StatsLegend({ columns, showPositionKey = false }: StatsLegendProps) {
  const entries = columns.filter((c) => c.def);
  if (entries.length === 0) return null;

  return (
    <div className={Styles.card}>
      {showPositionKey && (
        <div className={Styles.positionKey}>
          <span className={Styles.keyItem}>
            <span className={`${Styles.swatch} ${Styles.primary}`} />
            Primary position
          </span>
          <span className={Styles.keyItem}>
            <span className={`${Styles.swatch} ${Styles.secondary}`} />
            Secondary position
          </span>
        </div>
      )}
      <dl className={Styles.entries}>
        {entries.map((c, i) => (
          <div className={Styles.entry} key={`${c.field}-${i}`}>
            <span className={Styles.term}>{c.name}</span> - {c.def}
          </div>
        ))}
      </dl>
    </div>
  );
}
